import style from './PlainTextModule.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import * as React from 'react';

import { PlainTextAssembly } from 'src/api/contentful/contentTypes.cloverdotcom';
import { getField, isEntry } from 'src/utils/EntryUtil';

import { applyEntryDataAttributes } from '../EntryWrapper/EntryDataWrapper';
import { TextStack } from '../TextStack/TextStack';

interface IPlainTextModuleProps extends React.AllHTMLAttributes<HTMLElement>{
  entry?: ReferencedEntry<PlainTextAssembly>;
}

class PlainTextModule extends React.PureComponent<IPlainTextModuleProps> {
  render() {
    const { className, entry, ...otherProps } = this.props;

    const topic = getField(entry, 'topic');

    if (!isEntry(topic)) return null;

    return (
      <section className={cx(style.plainTextModuleWrapper, className)} {...otherProps}>
        <TextStack
          className={cx(style.plainTextModule)}
          entry={topic}
          titleTagName="h1"
          titleClassName={style.title}
          blurbClassName={style.blurb}
        />
      </section>
    );
  }
}

const Wrapped = applyEntryDataAttributes(PlainTextModule);

export { Wrapped as PlainTextModule };
